import { getInvariantDateString } from "src/utils/formatTime";
import { useBaseDataContext } from "../../hooks";
import { SendGeneralReportParams } from "./type";
import { BaseRiskReportParams } from 'src/@type/risk-management/types'
import { useCallback } from "react";

export default function useRiskReport<T, G, V extends BaseRiskReportParams>({
    route,
    controller,
    mapperDTOToModel
}: {
    route: string,
    controller: string,
    mapperDTOToModel: (dto: G) => T,
}) {
    const {
        actionBaseResult,
        getBaseResult,
    } = useBaseDataContext(route);

    const getReportData = useCallback(({ date, ...others }: V) => getBaseResult<T, G>({ 
        controller: controller, 
        params: { date: getInvariantDateString(date), ...others }, 
        mapperDTOToModel: mapperDTOToModel 
    }), [controller, getBaseResult, mapperDTOToModel]);

    const sendReport = useCallback((params :SendGeneralReportParams) => actionBaseResult({
        controller: controller,
        action: 'send',
        params: { 
            ...params,
            date: getInvariantDateString(params.date) 
        }
    }), [actionBaseResult, controller]);

    return {
        getReportData,
        sendReport
    }
}